interface LoadTimeoutProps {
  onRetry: () => void;
  label?: string;
}

/**
 * Shown when a loading gate exceeds its timeout. Deliberately keeps gating the
 * page (instead of rendering it with empty data, which would look like data
 * loss) and offers a manual retry that resubscribes the data sources.
 */
export default function LoadTimeout({ onRetry, label }: LoadTimeoutProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-4 px-6 py-20 text-center text-text-muted">
      <div className="text-base font-semibold text-text">
        {label || 'This is taking longer than usual'}
      </div>
      <div className="text-sm max-w-[420px]">
        The connection to the server may be interrupted. Your data is safe - try again.
      </div>
      <button
        onClick={onRetry}
        className="px-6 py-2.5 rounded-lg border border-border bg-surface text-text text-sm font-semibold
          cursor-pointer transition-all hover:bg-surface-hover hover:border-border-light tap:min-h-12"
      >
        Retry
      </button>
    </div>
  );
}
